module.exports = __webpack_public_path__ + "static/img/bg_coupon.ccbbf2d.png";


//////////////////
// WEBPACK FOOTER
// ./src/image/newVersion/bg_coupon.png
// module id = 335
// module chunks = 32